import { styled } from "@mui/material"
import { DetailedHTMLProps, HTMLAttributes } from "react"

const Logo = styled("span")({
  textAlign: "center",
  fontWeight: "100",
  letterSpacing: "4px",
  fontSize: "3rem",
  color: "#000",
  fontFamily: '"Abel", sans-serif',
  marginBottom: "10%",
  textTransform: "uppercase",
  lineHeight: 0.8,
})

type Props = DetailedHTMLProps<HTMLAttributes<HTMLSpanElement>, HTMLSpanElement>
const FoSLogoText = (props: Props) => {
  return <Logo {...props}>Foto&apos;s Op School</Logo>
}

export default FoSLogoText
